/* eslint-disable linebreak-style */
import { ClientMigration } from 'client-migration/clientMigration.types';
import request from '../api-request';

export async function getMigrationStatus(compid: number): Promise<ClientMigration | null> {
  if (compid <= 0) {
    throw new Error('Cannot get status for invalid company.');
  }

  const result = await request<ClientMigration | null>(`/api/client-migration/${compid}`);

  return result;
}
